export class WFECreateCommunityVendorParametersDto {
    workflowId: number;
    communityId: number;
    workflowStatus: string; // 	NOTE: Required for most endpoints of workflow editor except for getting data entry editor
    locationVendorId: number; // 	NOTE: This is VendorBranchAssociationId from WFEVendorResultDto. Make sure IsBranchVendor is true
}
